export default "__VITE_ASSET__0e7afce3__$_?used__"